import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { MainMenu } from './main-menu-item.interface';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainNavigationService {
  private http = inject(HttpClient);


  /* 
    Future use, this could be set from environment to access the backend API 
    on different hosts if required. For now it's just an empty string to assume 
    the same host name. See proxy.conf.json for the proxy configuration while
    developing the application.
  */
  private static API_HOST = environment.apiHost || '';

  getMainMenu(): Observable<MainMenu> {
    // return this.http.get<any>('/api/main-menu');
    return this.http.get<MainMenu>(`${MainNavigationService.API_HOST}/api/main-menu`);
  }

  getTeaType(teaTypeSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaTypeSlug)) {
      throw new Error('The provided tea type is not valid.');
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/teatype/${teaTypeSlug}`);
  }

  getTeasByType(teaTypeSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaTypeSlug)) {
      throw new Error('The provided tea type is not valid.');
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/teatype/${teaTypeSlug}/tea`);
  }

  getTeaRegion(teaRegionSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaRegionSlug)) {
      return throwError(() => new Error('The provided tea region is not valid.'));
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/region/${teaRegionSlug}`);
  }

  getTeasByRegion(teaRegionSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaRegionSlug)) {
      return throwError(() => new Error('The provided tea region is not valid.'));
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/region/${teaRegionSlug}/tea`);
  }

  getTeaFlavour(teaFlavourSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaFlavourSlug)) {
      return throwError(() => new Error('The provided tea flavour is not valid.'));
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/flavour/${teaFlavourSlug}`);
  }

  getTeasByFlavour(teaFlavourSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaFlavourSlug)) {
      return throwError(() => new Error('The provided tea flavour is not valid.'));
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/flavour/${teaFlavourSlug}/tea`);
  }
  
  getTeaItem(teaItemSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaItemSlug)) {
      throw new Error('The provided tea item is not valid.');
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/tea/${teaItemSlug}`);
  }

  getTeaItemProduct(teaItemProductSlug: string): Observable<any> {
    if (!/^[a-zA-Z0-9-]+$/.test(teaItemProductSlug)) {
      throw new Error('The provided tea item product is not valid.');
    }
    
    return this.http.get<any>(`${MainNavigationService.API_HOST}/api/tea-item/${teaItemProductSlug}`);
  }
}
